import React, { useState, useRef, useEffect } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { useSelector } from "react-redux";

import useDropdownPosition from "../../hooks/Dropdown/useDropDownPosition";
import CreatePortalHOC from "../../components/GlobalFeature/Fields/CreatePortalHOC";
import ShareIcon from "../../assets/images/icons/shareIcon.svg";
import z_ai_Icon from "../../assets/images/icons/z_ai.svg";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import FloatingList from "../UniversalComponents/FloatingElement";
import { ReactComponent as MoveToIcon } from "../../assets/images/msp_move_to.svg";
import { ReactComponent as CopyToIcon } from "../../assets/images/msp_copy_to.svg";
import { ReactComponent as ShareToIcon } from "../../assets/images/msp_share.svg";
import { ReactComponent as RenameIcon } from "../../assets/images/msp_rename.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/deleteSubTaskIcon.svg";
import { ReactComponent as ViewEyeIcon } from "../../assets/images/view_eye_icon.svg";
import { ReactComponent as PinIcon } from "../../assets/images/SpacePin.svg";
import { ReactComponent as ManageAccesIcon } from "../../assets/images/icons/ManageAccesIcon.svg";
import { ReactComponent as GreenPin } from "../../assets/images/green_pin.svg";

const FolderAction = ({
  Item,
  multiData = [],
  handleMove = () => {},
  handleShare = () => {},
  handleOverview = () => {},
  handleRequestAccess,
  handleEdit = () => {},
  handleDelete = () => {},
  handleView = () => {},
  handleDownload = () => {},
  handleManageAccess = () => {},
  handlePin = () => {},
  handleUnPin = () => {},
  showSharedFileFolder = false,
  accessType = "write", // "write" or "delete"
}) => {
  const { token } = useRequireAuth();
  const [isOpenHover, setIsOpenHover] = useState(false);
  const { dropdownPosition, dropdownRef } = useDropdownPosition(true, "fullscreen-table");
  const [dropdownCoord, setDropdownCoord] = useState(null);

  const popupRef = useRef(null);

  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      // closePopup();
    }
  };

  useEffect(() => {
    if (dropdownCoord !== null && !isOpenHover) {
      setIsOpenHover(true);
    }
  }, [dropdownCoord]);

  // useEffect(() => {
  //   if (tooltipCoord !== null && !isOpenTooltip) {
  //     setIsOpenHover(true);
  //   }
  // }, [tooltipCoord]);

  const getCreatePortalPosition = (ele) => {
    if (ele.current) {
      const rect = ele.current.getBoundingClientRect(); // Get the bounding rectangle
      const left = rect.left + 30;
      const top = rect.top - 15;
      return {
        top: top + window.scrollY,
        left: left + window.scrollX,
        borderRadius: "5",
      };
    }
  };

  const handleOpen = (event) => {
    event.stopPropagation();
    setDropdownCoord((prevState) => {
      return getCreatePortalPosition(dropdownRef);
    });
  };

  const handleClose = () => {
    setDropdownCoord(null);
    setIsOpenHover(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };

  const user = useSelector((store) => store.user);

  return (
    <div className={`flex gap-1 visible group-hover:visible`}>
      {(Item?.display_name?.includes(".pdf") || Item?.name?.includes(".pdf")) && (
        <div>
          <ToolTipComponent text={"AI Overview"}>
            <button className="p-1 hover:bg-[#F1F1F1] rounded group">
              <img
                className={`transition-transform -rotate-90 group-hover:rotate-0 w-4`}
                src={z_ai_Icon}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOverview(Item);
                  // handleClose();
                }}
              />
            </button>
          </ToolTipComponent>
        </div>
      )}
      {/* <div>
                <ToolTipComponent text={"Share"}>
                    <button className="p-1 hover:bg-[#F1F1F1] rounded mt-1">
                        <img
                            src={ShareIcon}
                            // className="w-5"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleShare(Item);
                                // handleClose();
                            }}
                        />
                    </button>
                </ToolTipComponent>
            </div> */}
      <div onMouseOver={handleOpen} onMouseLeave={handleClose}>
        <button
          type="button"
          id="threedot"
          className="threedot text-2541558A hover:text-254155 p-1 hover:bg-[#F1F1F1] rounded"
          disabled
          ref={dropdownRef}
        >
          <i className=" bi bi-three-dots text-14"></i>
        </button>
        {isOpenHover && (
          <FloatingList yMargin={-7} xMargin={-6} zIndex={10000} anchorParentRef={dropdownRef}>
            <div className="w-[200px] bg-white shadow-md rounded p-2">
              <div class="arrow-left "></div>
              {multiData.length < 2 && (
                <>
                  {/* <div className="p-1 m-1 hover:bg-[#F3F5F7] cursor-pointer">
                    <button
                      type="button"
                      className="flex items-center justify-between px-2 text-14  text-778FA5 hover:text-1D4469"
                    >
                      <PinIcon className="mr-1" />
                      <span className="ms-2">Pin</span>
                    </button>
                  </div> */}
                  {!showSharedFileFolder && (
                    <div
                      className="p-1 m-1 hover:bg-[#F3F5F7] cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleMove(Item, "move");
                        handleClose();
                      }}
                    >
                      <button
                        type="button"
                        className="flex items-center justify-between px-2 text-14 text-778FA5 hover:text-1D4469"
                      >
                        <MoveToIcon className="mr-[1px]" />
                        <span className="ms-2">Move To</span>
                      </button>
                    </div>
                  )}
                  {/* <div
                  className="p-1 m-1 cursor-not-allowed hover:bg-[#F3F5F7]"
                  onClick={(e) => {
                    e.stopPropagation();
                    // handleMove(Item, "copy-and-move");
                    // handleClose();
                  }}
                >
                  <button
                    type="button"
                    className="flex items-center justify-between cursor-not-allowed px-2 text-14 text-778FA5 hover:text-1D4469"
                  >
                    <CopyToIcon className="mr-[1px]" />
                    <span className="ms-2">Copy To</span>
                  </button>
                </div> */}
                  {!["folder", "table"].includes(Item?.type?.toLowerCase()) && (
                    <div
                      className="p-1 m-1 hover:bg-[#F3F5F7]"
                      onClick={(e) => {
                        e.stopPropagation();
                        // handleView(Item);
                        handleDownload(Item);
                        // handleMove(Item, "copy-and-move");
                        // handleClose();
                      }}
                    >
                      <button
                        type="button"
                        className="flex items-center justify-between px-2 text-14 text-778FA5 hover:text-1D4469"
                      >
                        <ViewEyeIcon className="mr-[1px]" />
                        <span className="ms-2">View</span>
                      </button>
                    </div>
                  )}
                  {!showSharedFileFolder && (
                    <div
                      className="p-1 m-1 hover:bg-[#F3F5F7]"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleManageAccess(Item);
                        handleClose();
                      }}
                    >
                      <button
                        type="button"
                        className="flex items-center justify-between px-2 text-14 text-778FA5 hover:text-1D4469"
                      >
                        <ManageAccesIcon className="mr-[1px]" />
                        <span className="ms-2">Manage Access</span>
                      </button>
                    </div>
                  )}
                  {!showSharedFileFolder && (
                    <div
                      className="p-1 m-1 hover:bg-[#F3F5F7]"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleShare(Item);
                        handleClose();
                      }}
                    >
                      <button
                        type="button"
                        className="flex items-center justify-between px-2 text-14 text-778FA5 hover:text-1D4469"
                      >
                        <ShareToIcon className="mr-[1px]" />
                        <span className="ms-2">Share</span>
                      </button>
                    </div>
                  )}
                  {!showSharedFileFolder && (
                    <div
                      className="p-1 m-1 hover:bg-[#F3F5F7]"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (Item?.is_pinned) {
                          handleUnPin(Item);
                        } else {
                          handlePin(Item);
                        }
                        handleClose();
                      }}
                    >
                      <button
                        type="button"
                        className="flex items-center justify-between px-2 text-14 text-778FA5 hover:text-1D4469"
                      >
                        <GreenPin className="mr-[1px]" />
                        <span className="ms-2">{Item?.is_pinned ? "Unpin" : "Pin"}</span>
                      </button>
                    </div>
                  )}
                  <div
                    className="p-1 m-1 hover:bg-[#F3F5F7] cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(Item);
                      handleClose();
                    }}
                  >
                    <button
                      type="button"
                      className="flex items-center justify-between px-2 text-14 text-778FA5 hover:text-1D4469"
                    >
                      <RenameIcon className="mr-[1px]" />
                      <span className="ms-2">Rename</span>
                    </button>
                  </div>
                  {(!showSharedFileFolder || accessType === "delete") && (
                    <div
                      className="p-1 m-1 hover:bg-[#F3F5F7] cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(Item);
                        handleClose();
                      }}
                    >
                      <button
                        type="button"
                        className="flex items-center justify-between px-2 text-14 text-778FA5 hover:text-1D4469"
                      >
                        <DeleteIcon className="mr-[1px]" />
                        <span className="ms-2">Delete</span>
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
            {/* </WithPortal> */}
          </FloatingList>
        )}
      </div>
    </div>
  );
};

export default FolderAction;
